import React, {FC} from 'react';

import {useRequiredQueryParams} from 'shared/hooks/use-required-query-params';
import {useAppDispatch, useAppSelector} from 'store/config/hooks';
import {EDocumentsSigningMethod, selectDocumentsSigningMethod} from 'store/slices/documents-uploading-slice';
import {openModal} from 'store/slices/modals-slice';

import {ActionButton} from '../action-button';
import {ITableActionProps} from '../table-action-types';

interface ITableOpenModalActionProps extends ITableActionProps {
}

export const TableOpenModalAction: FC<ITableOpenModalActionProps> = ({
    meta,
    wrapper,
    entityName,
    ...props
}: ITableOpenModalActionProps) => {
    const documentsSigningMethod = useAppSelector(selectDocumentsSigningMethod);

    const {
        modalName,
        actionCode,
        requiredQueryParams,
    } = meta;

    const {isDisabled} = useRequiredQueryParams({requiredQueryParams});

    const dispatch = useAppDispatch();
    const onClick = () => {
        if (modalName) {
            dispatch(openModal({
                modalName,
                entityName: meta?.modalEntityName || entityName,
                parentEntityName: entityName,
            }));
        }
    };

    if (actionCode === 'UPLOAD_SGN' && documentsSigningMethod === EDocumentsSigningMethod.CRYPTO_PRO_PLUGIN) return null;
    const Component = wrapper || ActionButton;
    return (
        <Component
            {...props}
            onClick={onClick}
            actionIcon={meta.actionIcon}
            disabled={isDisabled}
        >
            {meta.actionTitle}
        </Component>
    );
};
